import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { PiMapPinDuotone, PiForkKnifeDuotone } from "react-icons/pi";
import restaurantImg from "../../asset/images/restaurant.jpg";
import restaurant2Img from "../../asset/images/restaurant-2.jpg";
import restaurant3Img from "../../asset/images/restaurant-3.jpg";
import { DAYS, todayDay } from "./agenda";

// same photos on every restaurant page
const IMAGES = [restaurantImg, restaurant2Img, restaurant3Img];

// one restaurant per event day, same order as DAYS
const RESTAURANTS = [
  {
    name: "Flamingo Room by Tashas",
    theme: "",
    menu: "https://www.flamingoroombytashas.com/riyadh/menu",
    map: "https://maps.app.goo.gl/Wmy8RcqqeSXpQMRM8",
  },
  {
    name: "Court Yard",
    theme: "",
    menu: "https://www.flamingoroombytashas.com/riyadh/menu",
    map: "https://maps.app.goo.gl/rPoTwprFn53VV4Tx7",
  },
  {
    name: "Flamingo Room by Tashas",
    theme: "",
    menu: "https://www.flamingoroombytashas.com/riyadh/menu",
    map: "https://maps.app.goo.gl/Wmy8RcqqeSXpQMRM8",
  },
];

// no features string: Safari would open a popup window instead of a tab
const open = (url) => {
  const w = window.open(url, "_blank");
  if (w) w.opener = null;
};

const RestaurantPage = () => {

  document.title = "Restaurant | SNB";

  const navigate = useNavigate();
  const { day } = useParams();
  const restaurant = RESTAURANTS[+day - 1];
  const sliderRef = useRef(null);
  const [slide, setSlide] = useState(0);

  // auto-advance every 1.5s; a swipe changes `slide`, which restarts the timer
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const t = setTimeout(() => {
      const el = sliderRef.current;
      if (el) el.scrollTo({ left: ((slide + 1) % IMAGES.length) * el.clientWidth, behavior: "smooth" });
    }, 1500);
    return () => clearTimeout(t);
  }, [slide]);

  if (!restaurant) return <Navigate to="/agenda" replace />;

  const date = DAYS[+day - 1].date;

  return (
    <div className="home-wrapper app-wrapper restaurant-page">
      <div className="restaurant-hero">
        <div className="restaurant-topbar">
          <ArrowBackIosNewIcon role="button" fontSize="small" onClick={() => navigate(-1)} />
          <h1>Restaurant</h1>
        </div>
        <div
          className="restaurant-slider"
          ref={sliderRef}
          onScroll={(e) => setSlide(Math.round(e.target.scrollLeft / e.target.clientWidth))}
        >
          {IMAGES.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={restaurant.name}
              className="restaurant-img"
              role="button"
              onClick={() => open(restaurant.map)}
            />
          ))}
        </div>
        <div className="restaurant-dots">
          {IMAGES.map((_, i) => (
            <button
              key={i}
              aria-label={`Photo ${i + 1}`}
              className={i === slide ? "active" : ""}
              onClick={() => sliderRef.current.scrollTo({ left: i * sliderRef.current.clientWidth, behavior: "smooth" })}
            />
          ))}
        </div>
      </div>

      <div className="page-content">

        <div className="restaurant-row">
          <div>
            <div className="agenda-muted">Restaurant</div>
            {restaurant.name}
          </div>
        </div>

        {restaurant.theme && (
          <div className="restaurant-row">
            <div>
              <div className="agenda-muted">Theme</div>
              {restaurant.theme}
            </div>
          </div>
        )}

        <div className="restaurant-row">
          <div>
            <div className="agenda-muted">Date</div>
            {date.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
          </div>
        </div>

        <div className="restaurant-actions">
          <button className="restaurant-btn" onClick={() => open(restaurant.map)}>
            <PiMapPinDuotone />
            Location
          </button>
          {restaurant.menu && (
            <button className="restaurant-btn" onClick={() => open(restaurant.menu)}>
              <PiForkKnifeDuotone />
              Menu
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// /restaurant: pick the day first
export const RestaurantDatesPage = () => {

  document.title = "Restaurant | SNB";

  const navigate = useNavigate();
  const today = todayDay();

  return (
    <div className="home-wrapper app-wrapper agenda-page">
      <div className="page-content">
        <div className="agenda-topbar">
          <ArrowBackIosNewIcon role="button" fontSize="small" onClick={() => navigate("/home")} />
          <h1 className="agenda-day-title">Restaurant</h1>
          <span style={{ width: 20 }} />
        </div>

        <p className="agenda-muted">Select a date</p>

        <div className="restaurant-dates">
          {DAYS.map((d, i) => (
            <button
              key={d.key}
              className={`agenda-restaurant-link ${isTodayDay(i, today) ? "active" : ""}`}
              onClick={() => navigate(`/restaurant/${i + 1}`)}
            >
              <span className="restaurant-date-num">{d.date.getDate()}</span>
              <span>
                {d.date.toLocaleDateString("en-GB", { weekday: "long", month: "short", year: "numeric" })}
                <div className="agenda-muted">{RESTAURANTS[i].name}</div>
              </span>
              <ChevronRightRoundedIcon />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

// highlight only when today really is an event day (todayDay falls back to 1)
const isTodayDay = (i, today) => i + 1 === today && DAYS[i].date.toDateString() === new Date().toDateString();

export default RestaurantPage;
